import { render, staticRenderFns } from "./TestIdentifyFingerprint.vue?vue&type=template&id=2e210c1e&"
import script from "./TestIdentifyFingerprint.vue?vue&type=script&lang=js&"
export * from "./TestIdentifyFingerprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports